import GenericPokkService from "#/data-layer/GenericPokkService";

/**
 * Service for Breeding Values Comparison Genetic Trend.
 * Extends GenericPokkService to use POST for querying pages as required by the API.
 */
export class BreedingValuesComparisonGeneticTrendService extends GenericPokkService {
  constructor() {
    super({
      baseUrl: "/api/plemenske_vrednosti/primerjalni_genetski_trend",
    });
  }

  /**
   * Constructs the API endpoint URL based on the baseUrl and any additional parts provided.
   *
   * @param  {...any} parts
   * @returns string - The constructed API endpoint URL.
   */
  #endpoint(...parts) {
    return [this.baseUrl, ...parts.filter(Boolean)].join("/");
  }

  /**
   * Overrides the query method to use POST instead of GET.
   * Parameters are sent in the request body as JSON.
   *
   * @param {object} param
   * @returns {Promise<object>} - A promise that resolves with the query results.
   */
  async query({ body }) {
    return this.client
      .post(this.#endpoint(), body)
      .then(({ data }) => {
        return data;
      })
      .catch((err) => {
        const { status, data } = err.response || {};
        const error = {
          ...data,
          status,
          message: data?.resultMessages || err.message,
          response: err.response,
        };
        throw error;
      });
  }
}
